const LEVEL_THRESHOLDS = [0, 0, 1, 3, 5, 10] as const;
const MATCHES_PER_EXTRA_LEVEL = 5;
const MIN_PROGRESS_PERCENT = 20;

export function getCurrentLevelThreshold(level: number): number {
  if (level <= 5) {
    return LEVEL_THRESHOLDS[level];
  }
  return 10 + (level - 5) * MATCHES_PER_EXTRA_LEVEL;
}

export function getDuoLevelProgress(
  level: number,
  matchCount: number,
  nextLevelMatchCount: number,
): {
  matchesAtCurrentLevel: number;
  matchesNeededForNextLevel: number;
  progressPercent: number;
} {
  const currentLevelThreshold = getCurrentLevelThreshold(level);
  const matchesAtCurrentLevel = matchCount - currentLevelThreshold;
  const matchesNeededForNextLevel = nextLevelMatchCount - currentLevelThreshold;

  let progressPercent: number;
  if (matchesNeededForNextLevel === 0) {
    progressPercent = 100;
  } else {
    const rawProgress = matchesAtCurrentLevel / matchesNeededForNextLevel;
    // Scale progress to fit between MIN_PROGRESS_PERCENT and 100
    // 0% raw → 20%, 100% raw → 100%
    progressPercent = Math.round(
      MIN_PROGRESS_PERCENT + rawProgress * (100 - MIN_PROGRESS_PERCENT),
    );
  }

  return {
    matchesAtCurrentLevel,
    matchesNeededForNextLevel,
    progressPercent,
  };
}
